import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBP1DTv_A1JUHHVY_L37GRYHYzpaNbRotU",
  authDomain: "fulcrum-3714d.firebaseapp.com",
  projectId: "fulcrum-3714d",
  storageBucket: "fulcrum-3714d.firebasestorage.app",
  messagingSenderId: "695621384492",
  appId: "1:695621384492:web:e5969c1b026b68be2a5489",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
